var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grouped-avatars',{attrs:{"users":_vm.users}})
}
var staticRenderFns = []

export { render, staticRenderFns }